export default __webpack_public_path__ + "static/hero_img-07924f36200ebbb6e2ee2430db334af7.webp";